import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {API_ENDPOINT, toast_anim , pdfdoconly} from 'components/config/Common'
import {Loading} from "components/custom-icons";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

import axios from 'axios';  

import {APP_URL, APP_NAME , IMG_URL} from 'components/config/Common'
import FileInput from 'components/ui/file-input.jsx';

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'

import { yupResolver } from '@hookform/resolvers/yup';
import Input from 'components/ui/input.jsx'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import SelectInput from 'components/ui/select-input.jsx'
import Label from 'components/ui/label.tsx'
import Button from 'components/ui/Button.tsx'
import { Switch } from '@headlessui/react'
import PasswordInput from 'components/ui/password-input.tsx'

import {
	Control,
	FieldErrors,
	useForm,
	useFormState,
	useWatch,
	Controller
 } from 'react-hook-form';

/*	email: Yup.string()
		.required('You must need to provide email address.')
		.email('Invalid email.'),		*/
const SignupSchema = Yup.object().shape({
	name: Yup.string()
		.required('You must need to provide name.')
		.min(2, 'Name is too short!')
		.max(50, 'Name is too long!'),
});


let defaultValues = {  
	name: '',
	email:'',
	phone_no:'',
	password:'',
	gender:'',
};

const Profile = () => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
	const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
	const [user_me, setUser_me] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loading_social, setLoading_social] = useState(false);
	const [states, setStates] = useState(null);
    const [cities, setCities] = useState(false);
    const [enabled, setEnabled] = useState(false)

	const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
		defaultValues: defaultValues,
		
  	});

  		const refphone = useRef(null);

	useEffect(() => {
		getMyProfile()
		
	},[])
	

  const handleSelect = (val,name) => {  
		//console.log('cat val======',val,name.name)
		setError(name.name, null)
		setValue(name.name, val, true);
		
	}


	const getMyProfile = () => {
		console.log(access_token)
		fetch(`${API_ENDPOINT}/user_me`,{
			method: 'GET',
			headers : {        
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': 'Bearer '+access_token, 
			}
		}).then(function (response) {
				return response.json();
		}).then( (result)=> {
			console.log(result)
			setUser_me(result.data)
			let data = result.data
			defaultValues = {  
				name: data.name,
				email:data.email,
				gender:data.gender,
				phone_no:data.phone_no,
				user_name:data.user_name,
			};
			reset(defaultValues)
			
		})
	}	

	const siteMetadata = {
		url: `${APP_URL}/profile`,
		title:  `Update Profile | Change Password - ${APP_NAME}`,
		description: `Update Profile | Change Password ${APP_NAME}`,
	}

	const onSubmit = (values) => {
		
		setLoading(true)		

		let input = values;
     
      setLoading(true)
      axios.post(`${API_ENDPOINT}/update_user_profile`,input,{
         headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+access_token, 
         }
      }).then( (result)=> {
         /*console.log('data=====',result.data)
         console.log('IN UPDATE',result?.data?.data);
         setLoading(false)
         
         */
         //console.log('data=====',result?.data?.data?.name);
			if(result.data.status === 1){
				setLoading(false)
				localStorage.setItem('user_name',result?.data?.data?.name);
				toast_anim(result.data.message)
			}
      })
	}

	const changePassword = async (values) => {
		//console.log('value====', values)
		if(!values.current_password){
			setError("current_password", {
				type: "manual",
				message: "This field is required",
			});
			return 
		}
		if(!values.password){
			setError("password", {
				type: "manual",
				message: "This field is required",
			});
			return 
		}
		if(!values.password_confirmation){
			setError("password_confirmation", {
				type: "manual",
				message: "This field is required",
			});
			return 
		}

		if(values.password != values.password_confirmation){
			setError("password_confirmation", {
				type: "manual",
				message: "Password mis-match",
			});
			return 
		}

		let input = {
			"current_password": values.current_password,
			"password": values.password,
			"password_confirmation": values.password_confirmation
		}

		//console.log('input====', input)
		try {
			const res = await axios.post(`${API_ENDPOINT}/change-password`, input, {
			headers: {
				Authorization: `Bearer ${access_token}`,
			},
			});
			reset({
				current_password: "",
				password: "",
				password_confirmation: "",
			});
			toast_anim(res.data.message)
			//console.log(res.data.message);
		} catch (error) {
			if (error.response?.status === 422) {
				//console.log(error.response.data.errors);
				const backendErrors = error.response.data.errors;

				Object.keys(backendErrors).forEach((field) => {
				setError(field, {
					type: "server",
					message: backendErrors[field][0], // first error message
				});
				});
			}
		}
	}

	const ProfileSkeleton = () => {
		return (
			<div className="max-w-md mx-auto">
				<div className="h-4 w-20 bg-gray-200 rounded animate-pulse mb-2"></div>
				<div className="h-12 w-full bg-gray-200 rounded-md animate-pulse mb-5"></div>
				<div className="h-4 w-16 bg-gray-200 rounded animate-pulse mb-2"></div>
				<div className="h-12 w-full bg-gray-200 rounded-md animate-pulse mb-5"></div>
				<div className="h-4 w-28 bg-gray-200 rounded animate-pulse mb-2"></div>
				<div className="flex items-center gap-3 h-12 w-full bg-gray-200 rounded-md animate-pulse mb-6 px-3">
					<div className="h-5 w-8 bg-gray-300 rounded"></div>
					<div className="h-4 w-32 bg-gray-300 rounded"></div>
				</div>
				<div className="h-10 w-24 bg-gray-300 rounded-md animate-pulse"></div>
			</div>
		);
	};

	return (
		<ScrollPageTop>
			<ReactSEOMetaTags
				render={(el) => <Helmet>{el}</Helmet>}
				website={{ ...siteMetadata }}
				breadcrumb={[
					{ title: 'Home', url: `${APP_URL}` },
					{ title: 'Profile', url: `${APP_URL}/profile` },
				]}
			/>
         <LeftMenuLayout> 
				<div className="w-full">
					<div className={classNames('flex flex-col lg:flex-row gap-10 w-full p-5 md:p-8 bg-light dark:bg-gray-700 shadow rounded mb-8')}>
						<div className="w-full lg:w-[50%]">
						<p className="text-xl lg:text-2xl font-semibold text-heading capitalize mb-5 dark:text-zinc-400">My Profile</p>
						{
						user_me ?	
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="">
								<Input                
	                            label={`Name`}
	                            {...register('name')}
	                            variant="outline"
	                            className="mb-5"
	                            error={errors.name?.message}
	                            required
	                        	/>
	                        
	                        
	                        </div>

	                        <div className="">
								<Input                
		                            label={`Email`}
		                            {...register('email')}
		                            variant="outline"
		                            className="mb-5"
		                            type="email"
		                            error={errors.email?.message}
		                             disabled={true}
		                        />
		                       
							</div>
							<div>
		                     <label htmlFor="phone_no" className="block mb-3 text-sm font-semibold leading-none text-body-dark">Phone number </label>
		                     <Controller
		                        name="phone_no"
		                        control={control}
		                        ref={refphone}

		                        render={({ field }) => (
		                           <PhoneInput
		                              country="in"
		                              disableDropdown
		                              countryCodeEditable={false}
		                              inputClass="!p-0 ltr:!pr-4 rtl:!pl-4 ltr:!pl-14 rtl:!pr-14 !flex !items-center !w-full !appearance-none !transition !duration-300 !ease-in-out !text-heading !text-sm focus:!outline-none focus:!ring-0 !border !border-border-base !rounded focus:!border-accent !h-12"
		                              dropdownClass="focus:!ring-0 !border !border-border-base !shadow-350"
		                              {...field}
		                              disabled={false}
		                           />
		                        )}
		                     />
		                     <p className="my-2 text-xs text-start text-red-500">{errors.phone_no?.message}</p>
		                  </div>
							<div className="flex">
								{
								!loading
								?	
								<Button 
								className="my-2" 
								size="small"
								
								>Save</Button>
								:
								<Loading className="w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-assent-600 ltr:ml-auto" />
								}
							</div>
							</form>
						:
						<ProfileSkeleton />
						}
						</div>
						<div className="w-full lg:w-[50%]">
							<p className="text-xl lg:text-2xl font-semibold text-heading capitalize mb-5 dark:text-zinc-400">Change Password</p>
							<form onSubmit={handleSubmit(changePassword)}>
							<div className="mb-2 w-full flex flex-col">
								<PasswordInput                
								label={`Current Password`}
								{...register('current_password')}
								variant="outline"								
								type='password'
								error={errors.current_password?.message}
								required
								/>
							</div>
							<div className="mb-2 w-full flex flex-col">
								<PasswordInput                
								label={`Password`}
								{...register('password')}
								variant="outline"								
								type='password'
								error={errors.password?.message}
								required
								/>
							</div>
							<div className="mb-2 w-full flex flex-col">
								<PasswordInput                
								label={`Confirm Password`}
								{...register('password_confirmation')}
								variant="outline"
								type='password'
								error={errors.password_confirmation?.message}
								required
								/>
							</div>
							<Button 
								className="my-2" 
								size="small"
								
								>Change Password</Button>
							</form>
						</div>
					</div>
				</div>
		</LeftMenuLayout> 
      </ScrollPageTop>
   );
};

export default Profile